import React from 'react';
import './header.css';
import bg1 from '../../../assets/bg1.png';

const Header = () => {
  return (
    <div className='gpt3__header section_padding' id='home'>
      <div className='gpt3__header-content'>
        <h1>
          Impulsionando o Desenvolvimento Tecnológico em Moçambique
        </h1>
        <p>
        Somos 100% Moçambicanos, criando soluções inovadoras para moçambicanos. Nossa missão, visão e valores direcionam-nos na criação de produtos que transformam negócios e facilitam o dia a dia.
        </p>
        <div className='gpt3__header-content__input'>
          <input type='email' placeholder='Seu endereço email. Iremos entrar em contacto'/>
          <button type='button'>Enviar email</button>
        </div>

        {/* <div className='gpt3__header-content__people'>
          <img src={people} alt='peolple'/>
          <p>1,600 people requested access a visit in last 24 hours</p>
        </div> */}
      </div>
      <div className='gpt3__header-image'>
           <img src={bg1} alt='bg'/> 
        </div>
      
    </div>
  )
}

export default Header
